import Vue from 'vue'
import Vuex from 'vuex'
import { uploadSmoster } from '../provider/smosterProvider'
import { savePoster } from '../provider/posterProvider'
import { backendUrl } from '../util/endpointConfig'

Vue.use(Vuex)

const smosterEndpoint = backendUrl + 'smoster/'

export const store = new Vuex.Store({
  state: {
    smosterId
    : 'EKQLNMGB',
    initialPosterId: null,
    posterId: null,
    isPrintMode: false,
    isEditMode: false,
    error: null,
    isLeavingToCart: false,
    openUploadSmosterPromises: null,
    openSavePosterPromise: null,
    latestSmosterUploadStarted: null,
  },
  getters: {
    // Needs to be in edit mode an have an initialPosterId
    isValidEditState(state){
      return !!state.initialPosterId && state.isEditMode
    }
  },
  mutations: {
    addOpenUploadSmosterPromises(state, promise) {
      promise.catch((error) => {
        state.error = error
        throw error
      })
      state.openUploadSmosterPromises = Promise.all([
        state.openUploadSmosterPromises,
        promise,
      ])
    },
    addOpenSavePosterPromise(state, promise) {
      promise.catch((error) => {
        state.error = error
        throw error
      })
      state.openSavePosterPromise = promise
    },
    setError(state, error) {
      state.error = error
      throw error
    },
    setSmosterId(state, smosterId) {
      state.smosterId = smosterId
    },
    setPosterId(state, posterId) {
      state.posterId = posterId
    },
    setIsPrintMode(state, isPrintMode) {
      state.isPrintMode = isPrintMode
    },
    setIsEditMode(state, isEditMode) {
      state.isEditMode = isEditMode
    },
    setInitialPosterId(state, initialPosterId) {
      state.initialPosterId = initialPosterId
    },
    setIsLeavingToCart(state, isLeavingToCart) {
      state.isLeavingToCart = isLeavingToCart
    },
    setLatestSmosterUploadStarted(state, uploadStartTimestamp) {
      state.latestSmosterUploadStarted = uploadStartTimestamp
    },
  },
  actions: {
    async uploadAudio({ commit }, { file, type }) {
      try {
        let uploadUrl = smosterEndpoint
        if (type === 'FILE') {
          // Not getting the extension from file type because cloudconvert only understands mp3 not mpga
          uploadUrl = `${smosterEndpoint}/uploads/upload${
            file.name.match(/\.[0-9a-z]+$/i)[0]
          }`
        }

        const uploadSmosterPromise = uploadSmoster(file, uploadUrl)
        commit('addOpenUploadSmosterPromises', uploadSmosterPromise)
        await uploadSmosterPromise
        return Promise.resolve()
      } catch (e) {
        commit('setError', e)
      }
    },
    async savePoster({ state, commit }) {
      try {
        await state.openUploadSmosterPromises
        const savePosterPromise = savePoster()
        commit('addOpenSavePosterPromise', savePosterPromise)
        const posterId = await savePosterPromise
        commit('setPosterId', posterId)
      } catch (e) {
        commit('setError', e)
      }
    },
    async prepareAddToCart({ state, commit }) {
      try {
        commit('setIsLeavingToCart', true)
        await state.openUploadSmosterPromises
        await state.openSavePosterPromise
      } catch (e) {
        commit('setError', e)
      }
    },
  },
})
